import React from "react";

export const withLoading = conditionFn => Component => props =>
  <div>
    <Component {...props} />

    <div className="interactions">
      {conditionFn(props) &&
        <div className="sk-folding-cube">
          <div className="sk-cube1 sk-cube" />
          <div className="sk-cube2 sk-cube" />
          <div className="sk-cube4 sk-cube" />
          <div className="sk-cube3 sk-cube" />
        </div>}
    </div>
  </div>;



// WEBPACK FOOTER //
// ./src/components/hoc/withLoading.js